import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=23e17d3f&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23e17d3f')) {
      api.createRecord('23e17d3f', component.options)
    } else {
      api.reload('23e17d3f', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=23e17d3f&", function () {
      api.rerender('23e17d3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22oaMpNuyLMP3/JS/imageCarousel.vue"
export default component.exports